export default "__VITE_ASSET__65_7QV56__"